import React, { useMemo, useState } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";

export default function SignatoriesTable({ data, rows }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page") ?? 1) - 1,
    pageSize: Number(searchParams.get("page_size") ?? 50),
  });

  const handlePaginationModelChange = paginationModel => {
    searchParams.set("page", paginationModel.page + 1);
    searchParams.set("page_size", paginationModel.pageSize);

    setSearchParams(searchParams);
    setPaginationModel(paginationModel);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Nome",
        field: "nome",
        flex: 1,
        renderCell: params => params.row?.ASI_NOME,
      },
      {
        headerName: "E-mail",
        field: "email",
        flex: 1,
        renderCell: params => params.row?.ASI_EMAIL,
      },
      {
        headerName: "Ativo",
        field: "ativo",
        flex: 0.5,
        renderCell: params => (params.row?.ASI_ATIVO === "1" ? "Sim" : "Não"),
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Ações",
        width: 70,
        getActions: params => [
          <GridActionsCellItem
            onClick={() => {
              searchParams.set("signatory_id", params.row.ASI_ID);
              setSearchParams(searchParams);
            }}
            label="Editar"
            showInMenu
          />,
        ],
      },
    ],
    [searchParams, setSearchParams],
  );

  return (
    <DataGrid
      rows={data}
      columns={columns}
      getRowId={row => row.ASI_ID}
      sx={{ flex: 1, border: "none" }}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      rowCount={rows}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
}
